/**
 * Resolve whether a vendor rename should be committed.
 * - Trims the raw input.
 * - Skips the rename when the trimmed title is empty or unchanged from the current title.
 * @param {string} rawTitle - raw value from the rename input field
 * @param {string} currentTitle - the vendor's current title
 * @returns {string|null} the trimmed title to rename to, or null when no rename should happen
 */
export const getTrimmedTitleIfChanged = (rawTitle, currentTitle) => {
  const trimmedTitle = rawTitle.trim();
  if (!trimmedTitle || trimmedTitle === currentTitle) return null;
  return trimmedTitle;
};

export default getTrimmedTitleIfChanged;
